const SHOW_DELAY_MS = 400;

let pending = 0;
let visible = false;
let showTimer = null;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener(visible));
}

export function subscribeLoading(listener) {
  listeners.add(listener);
  listener(visible);
  return () => listeners.delete(listener);
}

export function beginTrackedRequest() {
  pending += 1;
  if (!showTimer && !visible) {
    showTimer = setTimeout(() => {
      showTimer = null;
      if (pending > 0) {
        visible = true;
        notify();
      }
    }, SHOW_DELAY_MS);
  }
}

export function endTrackedRequest() {
  pending = Math.max(0, pending - 1);
  if (pending > 0) {
    return;
  }
  if (showTimer) {
    clearTimeout(showTimer);
    showTimer = null;
  }
  if (visible) {
    visible = false;
    notify();
  }
}

export function isSilentRequest(config) {
  if (config?.silent === true || config?.silent === 1 || config?.silent === '1') {
    return true;
  }
  const headers = config?.headers || {};
  const value = headers['X-Silent-Request'] || headers['x-silent-request'];
  return value === '1' || value === 1 || value === true;
}
